import { filterTermToDate } from "../date/dateFilterTerms";
import { FilterOperator } from "../filterModel";
import type { ConditionFilterKind, DateFilterKind } from "../types";
import type { ConditionRow } from "./conditionChain";

/** Orders two terms of one column: negative, zero or positive, like `Array.prototype.sort`. */
export type RangeTermCompare = (a: string, b: string) => number;

/**
 * The order of a column's range bounds. A term that does not parse compares as equal to anything,
 * so the editor lets it through and the backend decides.
 */
export function compareRangeTerms(kind: ConditionFilterKind, dateKind: DateFilterKind = "date"): RangeTermCompare {
  if (kind === "number") return byValue(Number);
  if (kind === "date") return byValue((term) => filterTermToDate(term, dateKind)?.getTime() ?? NaN);
  return () => 0;
}

function byValue(read: (term: string) => number): RangeTermCompare {
  return (a, b) => {
    const difference = read(a) - read(b);
    return Number.isNaN(difference) ? 0 : difference;
  };
}

/** A Between whose From lies after its To: it matches nothing. */
export function isInvertedRange(row: ConditionRow, compare: RangeTermCompare): boolean {
  return (
    row.operator === FilterOperator.IN_RANGE &&
    row.term !== "" &&
    row.termTo !== "" &&
    compare(row.term, row.termTo) > 0
  );
}
